<p-menubar class="p-menubar-primary" [model]="items">
    <div class="app-logo">
        <!-- left nav changes container -->
        <a style="cursor: pointer; display: flex;" href="{{eolWebsiteUrl}}">
            <img class="half-logo" runat="server" src="assets/images/eurofins-icon.png" alt="Eurofins logo">
            <img class="full-logo" runat="server" src="assets/images/eurofins-logo-primary.png"
                alt="Eurofins logo">
        </a>
        <!-- end -->
    </div>
</p-menubar>